<template>
  <div>
    <div class="mt-5">
      <v-row>			
        <v-col cols="12" sm="6" md="6" class="align-stretch">
          <v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
            <v-row>
              <v-col
                cols="12"
                md="4"
                class="flex-row"
              >
                <v-skeleton-loader
                  v-bind="attrs"
                  type="image"
                  class="fill-height"
                ></v-skeleton-loader>
              </v-col>
              <v-col
                cols="12"
                md="8"
                class="flex-row"
              >
                <v-skeleton-loader
                  v-bind="attrs"
                  type="article"
                  class="fill-height"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <template>
          <v-col cols="12" sm="4" md="6" class="align-stretch">
            <v-card class="pa-8 elevation-0 rounded-lg hover-shadow fill-height mitra-card">
              <v-skeleton-loader
                v-bind="attrs"
                type="image"
                class="fill-height"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </div>

    <template v-if="isActiveMember">
      <div class="mt-5">
        <v-row>
          <v-col cols="12" sm="6" md="6" class="flex-stretch">
            <v-row>
              <v-col cols="6">
                <v-skeleton-loader
                  v-bind="attrs"
                  type="article"
                  class="fill-height"
                ></v-skeleton-loader>
              </v-col>

              <v-col cols="6">
                <v-skeleton-loader
                  v-bind="attrs"
                  type="article"
                  class="fill-height"
                ></v-skeleton-loader>
              </v-col>

              <v-col cols="6">
                <v-skeleton-loader
                v-bind="attrs"
                type="article"
                class="fill-height"
              ></v-skeleton-loader>
              </v-col>

              <v-col cols="6">
                <v-skeleton-loader
                  v-bind="attrs"
                  type="article"
                  class="fill-height"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" md="6" class="flex-stretch">
            <v-card class="pa-8 elevation-0 rounded-lg hover-shadow fill-height mitra-card">
              <v-skeleton-loader
                v-bind="attrs"
                type="image"
                class="fill-height"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div class="mt-5">
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-skeleton-loader
              v-bind="attrs"
              type="article"
              class="fill-height"
            ></v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-skeleton-loader
              v-bind="attrs"
              type="article"
              class="fill-height"
            ></v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-skeleton-loader
              v-bind="attrs"
              type="article"
              class="fill-height"
            ></v-skeleton-loader>
          </v-col>
        </v-row>	
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: ['isActiveMember', 'networkType'],
    data() {
      return {
        attrs: {
          class: '',
          boilerplate: true,
          elevation: 2,
        },
      }
    },
  }
</script>